import React, { useState, useEffect, useContext } from 'react';
import { UserContext } from '../components/userContext';
import { useHistory } from 'react-router';
import axios from 'axios';
import clsx from 'clsx';
import PropTypes from 'prop-types';

import { makeStyles, withStyles, lighten } from '@material-ui/core/styles';
import { 
  Button,
  Checkbox,
  CssBaseline,
  FormControl,
  FormControlLabel,
  FormGroup,
  FormLabel,
  Grid,
  IconButton,
  InputBase,
  Menu,
  MenuItem,
  Paper,
  Switch,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  TableSortLabel,
  TextField,
  Toolbar,
  Tooltip,
  Typography,
} from '@material-ui/core';
import AddBoxRoundedIcon from '@material-ui/icons/AddBoxRounded';
import AddCircleOutlineRoundedIcon from '@material-ui/icons/AddCircleOutlineRounded';
import AddCircleRoundedIcon from '@material-ui/icons/AddCircleRounded';
import AddRoundedIcon from '@material-ui/icons/AddRounded';
import CloseRoundedIcon from '@material-ui/icons/CloseRounded';
import DeleteRoundedIcon from '@material-ui/icons/DeleteRounded';
import EditRoundedIcon from '@material-ui/icons/EditRounded';
import FilterListIcon from '@material-ui/icons/FilterList';
import KeyboardArrowDownRoundedIcon from '@material-ui/icons/KeyboardArrowDownRounded';
import KeyboardArrowUpRoundedIcon from '@material-ui/icons/KeyboardArrowUpRounded';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import SearchRoundedIcon from '@material-ui/icons/SearchRounded';


const useToolbarStyles = makeStyles((theme) => ({
  toolbarContainer: {
    width: 'auto',
    overflowX: 'auto',
    overflowY: 'hidden'
  },
  root: {
    minWidth: 270,
    display: 'flex',
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
    backgroundColor: 'rgba(26, 26, 26, 0.975)',
  },
  highlight:
    theme.palette.type === 'light'
      ? {
          color: theme.palette.secondary.main,
          backgroundColor: lighten(theme.palette.secondary.light, 0.85),
        }
      : {
          color: theme.palette.text.primary,
          backgroundColor: theme.palette.secondary.dark,
        },
  title: {
    minWidth: '105px',
  },
  arrowDown: {
    width: '38px',
    height: '38px',
    '@media (max-width:750px)': {
      marginRight: '-12px'
    }
  },
  titleArrowClose: {
    '@media (max-width:599px)': {
      display: 'none',
    }
  },
  buttonAdd: {
    width: '38px',
    height: '38px',
    fontSize: 14,
    '& .MuiButton-root': {
      lineHeight: 0,
    }
  },
  grow: {
    flexGrow: 1
  },
  searchForm: {
    display: 'flex', 
    flexDirection: 'row', 
    alignItems: 'center', 
    position: 'relative', 
    justifyContent: 'flex-end', 
    width: '275px',
    '@media (max-width:599px)': {
      width: '100%'
    }
  },
  inputBaseClose: {
    height: '38px',
    width: '38px',
    visibility: 'hidden',
    borderRadius: '19px',
    fontSize: '14px',
    backgroundColor: 'rgba(22, 22, 22, 1)',
    color: theme.palette.text.secondary,
    '& .MuiInputBase-input': {
      padding: '12px',
      height: '100%'
    },
    transition: 'all 0.3s ease',
  },
  inputBaseOpen: {
    width: '100%',
    visibility: 'visible',
    transition: 'all 0.5s ease',
    '& .MuiInputBase-input': {
      paddingRight: '26px',
    },
  },
  searchIconClose: {
    display: 'flex', 
    alignItems: 'center', 
    justifyContent: 'center', 
    position: 'absolute', 
    right: 0, 
    top: 0,
    height: '100%', 
    width: '38px', 
    borderRadius: '19px',
    cursor: 'pointer',
    '&:hover': {
      backgroundColor: 'rgba(40, 40, 40, 1)'
    }
  },
  searchIconOpen: {
    backgroundColor: 'rgba(22, 22, 22, 1)',
  },
  slider: {
    height: 0
  },
  filterFieldClose: {
    backgroundColor: 'rgba(26, 26, 26, 0.975)',
    opacity: 0,
    display: 'flex',
    height: 0,
  },
  filterFieldOpen: {
    height: 'auto',
    padding: 8,
    opacity: 1,
    borderTop: '1px solid rgba(81, 81, 81, 1)',
    transition: 'opacity 0.5s ease-in',
    '@media (max-width:750px)': {
      marginTop: 4,
      borderTop: 'none',
    }
  },
  filterInput: {
    fontSize: 12,
    display: 'flex',
    alignItems: 'center',
    height: '38px',
    width: '100%',
    borderRadius: '19px',
    fontSize: '14px',
    backgroundColor: 'rgba(22, 22, 22, 1)',
    color: theme.palette.text.secondary,
    '& .MuiInputBase-input': {
      paddingLeft: '12px',
      height: '100%'
    },
    '& p': {
      fontSize: 12,
      paddingRight: 12,
      fontStyle: 'italic'
    },
  },
  playerModeCheck: {
    '& .MuiTypography-body1': {
      fontSize: 12
    }
  },
  gameModeContainer: {
    '& .MuiSvgIcon-root': {
      width: '0.75em',
      height: '0.75em'
    }
  },
  buttonFilter: {
    width: '50%', 
    backgroundColor: 'rgba(255, 255, 255, 0.08)', 
    borderRadius: 0,
  }
}));

const CustomTableToolbar = (props) => {
  const classes = useToolbarStyles();
  const { user, games, setGames, showFilteredItems, setShowFilteredItems, selected, numSelected, onResetFilter, history } = props;
  const [ searchValue, setSearchValue ] = React.useState("");
  const [ searchField, setSearchField ] = React.useState(false);
  const [ filterField, setFilterField ] = React.useState(false); 
  const [ filterValue, setFilterValue ] = React.useState({genre: '', release: '', platform: '', singlePlayer: false, multiplayer: false});
  

  // Search
  const submitSearch = (e) => {
    e.preventDefault();

    axios.get(`https://backendexample.sanbersy.com/api/data-game`).then((res) => {
      let data = res.data;
      let resGames = data.map(el  => {
        if (Boolean(el.name) === false) el.name = " ";
        if (Boolean(el.genre) === false) el.genre = " ";
        if (Boolean(el.release) === false) el.release = " ";
        if (Boolean(el.platform) === false) el.platform = " ";
        if (Boolean(el.singlePlayer) === false) el.singlePlayer = 0;
        if (Boolean(el.multiplayer) === false) el.multiplayer = 0;
        let name = el.name.charAt(0).toUpperCase() + el.name.slice(1)
        let genre = el.genre.charAt(0).toUpperCase() + el.genre.slice(1)
        let platform = el.platform.charAt(0).toUpperCase() + el.platform.slice(1)
        const { id, release, singlePlayer, multiplayer, image_url } = el;
        return { id, name, release, genre, platform, singlePlayer, multiplayer, image_url };
      })
      
      let filteredName = resGames.filter(game => game.name.toLowerCase().indexOf(searchValue.toLowerCase()) !== -1);
      let filteredGenre = resGames.filter(game => game.genre.toLowerCase().indexOf(searchValue.toLowerCase()) !== -1);
      let filteredRelease = resGames.filter(game => game.release.toLowerCase().indexOf(searchValue.toLowerCase()) !== -1);
      let filteredPlatform = resGames.filter(game => game.platform.toLowerCase().indexOf(searchValue.toLowerCase()) !== -1);
      let filteredSingle = resGames.filter(game => {
        if ("singlePlayer".toLowerCase().includes(searchValue.toLowerCase())) return game.singlePlayer === 1;
      })
      let filteredMulti = resGames.filter(game => {
        if ("multiplayer".toLowerCase().includes(searchValue.toLowerCase())) return game.multiplayer === 1;
      })
      let result = [...filteredName, ...filteredGenre, ...filteredRelease, ...filteredPlatform, ...filteredSingle, ...filteredMulti];
      setGames([...new Set(result)]);
    })
    setShowFilteredItems(true);    
  }

  const searchChange = (e) => {
    setSearchValue(e.target.value);
  }

  // Filter
  const submitFilter = (e) => {
    e.preventDefault();

    axios.get(`https://backendexample.sanbersy.com/api/data-game`).then((res) => {
      let data = res.data;
      let resGames = data.map(el => {
        if (Boolean(el.name) === false) el.name = " ";
                if (Boolean(el.genre) === false) el.genre = " ";
                if (Boolean(el.release) === false) el.release = " ";
                if (Boolean(el.platform) === false) el.platform = " ";
                if (Boolean(el.singlePlayer) === false) el.singlePlayer = 0;
                if (Boolean(el.multiplayer) === false) el.multiplayer = 0;
                let name = el.name.charAt(0).toUpperCase() + el.name.slice(1)
                let genre = el.genre.charAt(0).toUpperCase() + el.genre.slice(1)
                let platform = el.platform.charAt(0).toUpperCase() + el.platform.slice(1)
                const { id, release, singlePlayer, multiplayer, image_url } = el;
                return { id, name, release, genre, platform, singlePlayer, multiplayer, image_url };
      })
      let result = [];

      // Case 1
      if (filterValue.genre !== '' && filterValue.release !== null && filterValue.platform !== '') {
        result = resGames
        .filter(game => game.genre.toLowerCase().indexOf(filterValue.genre.toLowerCase()) !== -1)
        .filter(game => game.release.toLowerCase().indexOf(filterValue.release.toLowerCase()) !== -1)
        .filter(game => game.platform.toLowerCase().indexOf(filterValue.platform.toLowerCase()) !== -1)
        console.log('genre, release, platform')
        if (filterValue.singlePlayer == true || filterValue.multiplayer == true) {
          result = result.filter(game => game.singlePlayer == filterValue.singlePlayer && game.multiplayer == filterValue.multiplayer) 
          console.log('genre, release, platform OK')
        }
      }

      if (filterValue.genre !== '' && filterValue.release !== null && filterValue.platform === '') {
        result = resGames
        .filter(game => game.genre.toLowerCase().indexOf(filterValue.genre.toLowerCase()) !== -1)
        .filter(game => game.release.toLowerCase().indexOf(filterValue.release.toLowerCase()) !== -1)
        console.log('genre, release')
        if (filterValue.singlePlayer == true || filterValue.multiplayer == true) {
          result = result.filter(game => game.singlePlayer == filterValue.singlePlayer && game.multiplayer == filterValue.multiplayer)
          console.log('genre, release Ok')
        }
      }

      if (filterValue.genre !== '' && filterValue.release === null && filterValue.platform !== '') {
        result = resGames
        .filter(game => game.genre.toLowerCase().indexOf(filterValue.genre.toLowerCase()) !== -1)
        .filter(game => game.platform.toLowerCase().indexOf(filterValue.platform.toLowerCase()) !== -1)
        console.log('genre, platform')
        if (filterValue.singlePlayer == true || filterValue.multiplayer == true) {
          result = result.filter(game => game.singlePlayer == filterValue.singlePlayer && game.multiplayer == filterValue.multiplayer)
          console.log('genre, platform OK')
        }
      }

      if (filterValue.genre !== '' && filterValue.release === null && filterValue.platform === '') {
        result = resGames
        .filter(game => game.genre.toLowerCase().indexOf(filterValue.genre.toLowerCase()) !== -1)
        console.log('genre')
        if (filterValue.singlePlayer == true || filterValue.multiplayer == true) {
          result = result.filter(game => game.singlePlayer == filterValue.singlePlayer && game.multiplayer == filterValue.multiplayer)
          console.log('genre OK')
        }
      }
      
      // Case 2
      if (filterValue.genre === '' && filterValue.release !== null && filterValue.platform !== '') {
        result = resGames
        .filter(game => game.release.toLowerCase().indexOf(filterValue.release.toLowerCase()) !== -1)
        .filter(game => game.platform.toLowerCase().indexOf(filterValue.platform.toLowerCase()) !== -1)
        console.log('release, platform')
        if (filterValue.singlePlayer == true || filterValue.multiplayer == true) {
          result = result.filter(game => game.singlePlayer == filterValue.singlePlayer && game.multiplayer == filterValue.multiplayer)
          console.log('release, platform OK')
        }
      }

      if (filterValue.genre === '' && filterValue.release !== null && filterValue.platform === '') {
        result = resGames
        .filter(game => game.release.toLowerCase().indexOf(filterValue.release.toLowerCase()) !== -1)
        console.log('release')
        if (filterValue.singlePlayer == true || filterValue.multiplayer == true) {
          result = result.filter(game => game.singlePlayer == filterValue.singlePlayer && game.multiplayer == filterValue.multiplayer)
          console.log('release OK')
        }
      }

      if (filterValue.genre === '' && filterValue.release === null && filterValue.platform !== '') {
        result = resGames
        .filter(game => game.platform.toLowerCase().indexOf(filterValue.platform.toLowerCase()) !== -1)
        console.log('platform')
        if (filterValue.singlePlayer == true || filterValue.multiplayer == true) {
          result = result.filter(game => game.singlePlayer == filterValue.singlePlayer && game.multiplayer == filterValue.multiplayer)
          console.log('platform OK')
        }
      }

      if (filterValue.genre === '' && filterValue.release === null && filterValue.platform === '' ) {
        console.log('none')
        if (filterValue.singlePlayer == true || filterValue.multiplayer == true) {
          result = resGames.filter(game => game.singlePlayer == filterValue.singlePlayer && game.multiplayer == filterValue.multiplayer)
          console.log('none OK')
        }
      }

      setGames([...result]);
    }) 
    setShowFilteredItems(true);   
  }
  
  const filterChange = (event) => {
    setFilterValue({ ...filterValue, [event.target.name]: event.target.value });
  }
  
  const checkboxChange = (event) => {
    console.log(filterValue)
    setFilterValue({ ...filterValue, [event.target.name]: event.target.checked });
  }

  const resetFilter = () => {
    setShowFilteredItems(false);
    onResetFilter();
  }

  // Tooltip
  const handleDeleteToolbar = () => {
    console.log(selected)
  }

  const handleCreate = () => {
    history.push(`/${user.email}/dashboard/game-editor/create`);
  }
 
  const handleSearchField = () => {
    setSearchField(!searchField);
  }
  
  const handleFilterField = () => {
    setFilterField(!filterField)
  }

  return (
    <>
      <div className={classes.toolbarContainer}>
        <Toolbar
          className={clsx(classes.root, {
            [classes.highlight]: numSelected > 0,
          })}
        >
          {numSelected > 0 ? (
            <Typography style={{flex: '1 1 100%'}} color="inherit" variant="subtitle1" component="div">
              {numSelected} {numSelected < 2 ? "item selected" : "items selected" }
            </Typography>
          ) : (
            <Typography className={clsx(classes.title, searchField && classes.titleArrowClose)} variant="h6" id="tableTitle" component="div">
              Games List
            </Typography>
          )}

          {numSelected > 0 ? (
            <Tooltip title="Delete selected items">
              <IconButton onClick={handleDeleteToolbar} aria-label="delete" style={{width: 38, height: 38}}>
                <DeleteRoundedIcon />
              </IconButton>
            </Tooltip>
          ) : (
            <>
              <div className={classes.grow}></div>
              <form onSubmit={submitSearch} className={classes.searchForm}>
                <InputBase 
                  type="text" 
                  title="search by name, genre, release, platform and mode" 
                  placeholder="Type anything..." 
                  title="Search"
                  value={searchValue} 
                  onChange={searchChange} 
                  className={clsx(classes.inputBaseClose, searchField && classes.inputBaseOpen)} 
                />
                <IconButton 
                  onClick={handleSearchField}
                  disableFocusRipple
                  disableRipple
                  className={clsx(classes.searchIconClose, searchField && classes.searchIconOpen)}  
                >
                  <SearchRoundedIcon />
                </IconButton>
              </form>
              <IconButton 
                className={clsx(classes.buttonAdd, searchField && classes.titleArrowClose)}
                onClick={handleCreate}
                disableFocusRipple
                disableRipple
                title="Add New Game"
              >
                <AddCircleRoundedIcon />
              </IconButton>
              <IconButton 
                className={clsx(classes.arrowDown, searchField && classes.titleArrowClose)}
                onClick={handleFilterField}
                disableFocusRipple
                disableRipple
                title="Filter"
              >
                { filterField ?
                  <KeyboardArrowUpRoundedIcon /> : <FilterListIcon />
                }
              </IconButton>
            </>
          )}
        </Toolbar>
        {showFilteredItems && (
          <div style={{display: 'flex', padding: '8px 16px', backgroundColor: 'rgba(26, 26, 26, 0.975)', marginTop: 4}}>
            <div style={{display: 'inline-flex', alignItems: 'center', backgroundColor: '#202020', height: 30, borderRadius: 15, padding: '0px 16px'}}>
              <span>{games.length} {games.length > 1 ? "items found" : "item found"}</span>
            </div>
          </div>
        )}
        <form onSubmit={submitFilter} style={{minWidth: 270}}>
          <Grid 
            container 
            className={clsx(classes.filterFieldClose, filterField && classes.filterFieldOpen)}      
          >
            <Grid item xs={12} style={{paddingLeft: '8px', fontSize: '16px'}}>Filter</Grid>
            <Grid item xs={12} lg={6} sm={6} style={{display: 'flex', padding: '8px', alignItems: 'center'}}>
              <InputBase
                fullwidth
                className={classes.filterInput}
                type="text" 
                title="filter by genre" 
                placeholder="Filter by genre" 
                name="genre"
                value={filterValue.genre} 
                onChange={filterChange} 
              />
            </Grid>
            <Grid item xs={12} lg={6} sm={6} style={{display: 'flex', padding: '8px', alignItems: 'center'}}>
              <InputBase
                fullwidth
                className={classes.filterInput}
                type="number"
                title="filter by release year" 
                placeholder="Filter by release year" 
                name="release"
                value={filterValue.release} 
                onChange={filterChange} 
              />
            </Grid>
            <Grid item xs={12} lg={6} sm={6} style={{display: 'flex', padding: '8px', alignItems: 'center'}}>
              <InputBase 
                fullwidth
                className={classes.filterInput}
                type="text" 
                title="filter by platform" 
                placeholder="Filter by platform" 
                // inputProps={{min: 0, max: 10}}
                // min={0}
                // max={10}
                name="platform"
                value={filterValue.platform} 
                onChange={filterChange} 
                // endAdornment={<InputAdornment position="end">mins</InputAdornment>}
              />
            </Grid>
            <Grid item xs={12} lg={4} sm={6} style={{padding: '8px', alignItems: 'center'}}>
              <FormControl component="fieldset" style={{padding: '0 4px'}}>
                <FormLabel 
                  component="legend" 
                  style={{fontStyle: "italic", fontSize: '12px', color: 'rgba(144, 144, 144, 1)'}}
                >
                  Game Mode :
                </FormLabel>
                <FormGroup row className={classes.gameModeContainer}>
                  <FormControlLabel
                    className={classes.playerModeCheck}
                    control={<Checkbox style={{width: 38, height: 38}} checked={filterValue.singlePlayer} onChange={checkboxChange} name="singlePlayer" />}
                    label="Single Player"
                  />
                  <FormControlLabel
                    className={classes.playerModeCheck}
                    control={<Checkbox style={{width: 38, height: 38}} checked={filterValue.multiplayer} onChange={checkboxChange} name="multiplayer" />}
                    label="Multi Player"
                  />
                </FormGroup>
              </FormControl>
            </Grid>
            <Grid item xs={12} lg={2} style={{padding: '8px', justifyContent: 'center', alignItems: 'center', display: 'flex'}}>
              <Button type="submit" className={classes.buttonFilter}>
                Filter
              </Button>
              &nbsp;
              <Button onClick={resetFilter} className={classes.buttonFilter}>
                Reset
              </Button>
            </Grid>
          </Grid>
        </form>
      </div>
    </>
  );
};

CustomTableToolbar.propTypes = {
  numSelected: PropTypes.number.isRequired,
};

const CustomSwitch = withStyles({
  switchBase: {
    color: 'rgba(60, 60, 60, 1)',
    '&$checked': {
      color: '#fff',
    },
    '&$checked + $track': {
      color: 'blue',
      backgroundColor: 'rgba(120, 120, 120, 1)',
    },
  },
  checked: {},
  track: {},
})(Switch);

function CustomTableHead(props) {
  const { classes, onSelectAllClick, games, order, orderBy, setOrderBy, numSelected, rowCount, onRequestSort, headCells, setHeadCells } = props;
  const [ anchorEl, setAnchorEl ] = React.useState(null);
  const [ hiddenCells, setHiddenCells ] = React.useState('');
  const [ filterSwitch, setFilterSwitch ] = React.useState(["name", "image", "genre", "release", "platform", "mode", "action"]);
  // const open = Boolean(anchorEl);
  const [ searchFilterValue, setSearchFilterValue ] = React.useState('');
  const [ columnMenu, setColumnMenu ] = React.useState(false);

  const createSortHandler = (property) => (event) => {
    onRequestSort(event, property);
  };

  const handleOpen = (event) => {
    console.log(event.currentTarget.value);
    setHiddenCells(event.currentTarget.value)
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleChangeSwitch = (event) => {
    let name = event.target.name;
    let value = event.target.checked;
    return setHeadCells(headCells.map(headCell => headCell.id === name ? {...headCell, isVisible: value} : headCell));
    console.log(headCells)
    // let result = [];
    // if (name === "name") {
    //   result = headCells.filter(headCell => headCell.id !== "name")
    // }
    // console.log(result)
  };

  const searchFilterChange = (event) => {
    setSearchFilterValue(event.target.value);
    setFilterSwitch(["name", "image", "genre", "release", "platform", "mode", "action"].filter((v,i) => v.toLowerCase().indexOf(event.target.value.toLowerCase()) !== -1));
  }

  const hideAllColumn = () => {
    setHeadCells(headCells.map(headCell => ({ ...headCell, isVisible: false }) ))
  }

  const showAllColumn = () => {
    setHeadCells(headCells.map(headCell => ({ ...headCell, isVisible: true }) ))
  }

  const handleClick = (event) => {
    if (event.target.getAttribute("value") === "unsort") setOrderBy('');
    if (event.target.innerText === "Hide Column") {
      setHeadCells(headCells.map(headCell => headCell.id === hiddenCells ? {...headCell, isVisible: false} : headCell));
    }
    if (event.target.innerText === "Show Column") {
      setColumnMenu(true);
    }
    setAnchorEl(null);
  }
  
  return (
    <>
      <TableHead className={classes.tableHead}>
        <TableRow>
          <TableCell
            align="center"
            className={classes.checkbox}
          >
            <Checkbox
              indeterminate={numSelected > 0 && numSelected < rowCount}
              checked={rowCount > 0 && numSelected === rowCount}
              onChange={onSelectAllClick}
              inputProps={{ 'aria-label': 'select all games' }}
            />
          </TableCell>
          {headCells.filter(headCell => headCell.isVisible === true).map((headCell, index) => (
            <TableCell 
              // style={{position: 'relative'}}
              key={headCell.id}
              align={headCell.align}
              padding={headCell.disablePadding ? 'none' : 'normal'}
              sortDirection={orderBy === headCell.id ? order : false}
              classes={{
                root: classes.normalCell,
                sizeSmall: classes.smallCell
              }}
            >
              {headCell.align === "left" && (
                <div className={classes.moreVertContainerLeft}>
                  {headCell.isSorted ?
                    <>
                      <TableSortLabel
                        active={orderBy === headCell.id}
                        direction={orderBy === headCell.id ? order : 'asc'}
                        onClick={createSortHandler(headCell.id)}
                        title={`Sort by ${headCell.label}`}
                      >
                        {headCell.label}
                        {orderBy === headCell.id ? (
                          <span className={classes.visuallyHidden}>
                            {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                          </span>
                        ) : null} 
                      </TableSortLabel>
                      <span style={{flexGrow: 1}}></span>
                      <IconButton title="Menu" value={headCell.id} className={classes.iconButtonVert} style={{marginRight: '-12px'}} onClick={handleOpen}>
                        <MoreVertIcon fontSize="small" className={classes.moreVert} />
                      </IconButton>
                    </>
                  :
                    <>
                      {headCell.label}
                      <span style={{flexGrow: 1}}></span>
                      <IconButton title="Menu" value={headCell.id} className={classes.iconButtonVert} style={{marginRight: '-12px'}} onClick={handleOpen}>
                        <MoreVertIcon fontSize="small" className={classes.moreVert} />
                      </IconButton>
                    </>
                  }
                </div>)
              }

              {headCell.align === "right" && (
                <div className={classes.moreVertContainerRight}>
                  {headCell.isSorted ?
                    <>
                      <TableSortLabel
                        active={orderBy === headCell.id}
                        direction={orderBy === headCell.id ? order : 'asc'}
                        onClick={createSortHandler(headCell.id)}
                        title="Sort"
                      >
                        {headCell.label}
                        {orderBy === headCell.id ? (
                          <span className={classes.visuallyHidden}>
                            {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                          </span>
                        ) : null} 
                      </TableSortLabel>
                      <span style={{flexGrow: 1}}></span>
                      <IconButton title="Menu" value={headCell.id} className={classes.iconButtonVert} style={{marginLeft: '-12px'}} onClick={handleOpen}>
                        <MoreVertIcon fontSize="small" className={classes.moreVert} />
                      </IconButton>
                    </>
                  :
                    <>{headCell.label}</>
                  }
                </div>)
              }

                {headCell.align === "center" && (<>{headCell.label}</>)}
              </TableCell>
          ))}
          {/* {games.length === 0 && (
            <TableRow>
              {headCells.map(v => v.isVisible === false && <TableCell></TableCell>)}
            </TableRow>
          )} */}
          <Menu
            id="simple-menu"
            anchorEl={anchorEl}
            keepMounted
            open={Boolean(anchorEl)}
            onClose={handleClose}
          >
            {orderBy !== '' && <MenuItem value="unsort" onClick={handleClick}>Unsort All</MenuItem>}
            <MenuItem value="hide" onClick={handleClick}>Hide Column</MenuItem>
            <MenuItem value="show" onClick={handleClick}>Show Column</MenuItem>
          </Menu>
        </TableRow>
      </TableHead>
      <div className={clsx(classes.switch, {[classes.switchOpen]: columnMenu} )}>
        <FormControl component="fieldset" style={{width: "300px"}}>
          {/* <FormLabel component="legend" style={{cursor: 'default', fontSize: '16px', fontWeight: 400, marginBottom: 8}}>Hide / Show Column</FormLabel> */}
          <div style={{display: 'flex', flexDirection: 'row-reverse', alignItems: 'center'}}>  
            <IconButton 
              style={{textAlign: 'right', width: 28, height: 28, padding: 8, marginRight: '-8px'}}
              onClick={() => setColumnMenu(false)}
            >
              <CloseRoundedIcon fontSize='small' />
            </IconButton>
            <span style={{fontSize: '14px', flexGrow: 1, fontWeight: 400}}>Hide / Show Column</span>
          </div>
          <FormGroup>
            <TextField className={classes.searchSwitch} 
              // style={{marginBottom: 12}}
              type="text"
              // color="secondary"
              label="Find Column" 
              placeholder="Column Title" 
              value={searchFilterValue} 
              onChange={searchFilterChange} 
            />
            <Grid container style={{marginBottom: 12}}>
              {filterSwitch.map((text, index) => (
                <Grid item sm={6}>
                  <FormControlLabel
                    control={<CustomSwitch checked={headCells[index].isVisible} onChange={handleChangeSwitch} name={text} />}
                    label={text}
                  />
                </Grid>
              ))}
            </Grid>
            <Grid container style={{marginBottom: 12}}>
              <Grid item sm={6}>
                <Button fullWidth variant="text" style={{borderRadius: 0}} onClick={hideAllColumn}>
                  Hide All
                </Button>
              </Grid>
              <Grid item sm={6}>
                <Button fullWidth variant="text" style={{borderRadius: 0}} onClick={showAllColumn}>
                  Show All
                </Button>
              </Grid>  
            </Grid>
          </FormGroup>
        </FormControl>
      </div>
    </>
  );
}

CustomTableHead.propTypes = {
  classes: PropTypes.object.isRequired,
  numSelected: PropTypes.number.isRequired,
  onRequestSort: PropTypes.func.isRequired,
  onSelectAllClick: PropTypes.func.isRequired,
  order: PropTypes.oneOf(['asc', 'desc']).isRequired,
  orderBy: PropTypes.string.isRequired,
  rowCount: PropTypes.number.isRequired,
};

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
  },
  paper: {
    minWidth: 270,
    width: '100%',
    marginBottom: theme.spacing(2),
  },
  sortMobileContainer: {
    display: 'none',
    alignItems: 'center', 
    padding: '8px', 
    backgroundColor: 'rgba(26, 26, 26, 0.975)',
    marginBottom: 4,
    // marginTop: 4,
    // borderTop: '1px solid rgba(81, 81, 81, 1)',
    // marginTop: 4,
    '@media (max-width:750px)': {
      display: 'flex', 
    }
  },
  sortMobile: {
    display: 'flex',
    alignItems: 'center',
    height: 48,
    padding: 8, 
    '& .Mui-focused': {
      color: theme.palette.text.secondary
    },
    '& .MuiFormControl-marginNormal': {
      marginTop: 8
    },
    '& .MuiFormControl-root': {
      width: '100%',
    },
    '& .MuiInputBase-root': {
      height: 42,
      lineHeight: '1rem'
    },
    '& .MuiOutlinedInput-root': {
      borderRadius: '21px'
    },
    '& .MuiInputLabel-outlined': {
      transform: 'translate(14px, 13px) scale(1)'
    },
    '& .MuiInputLabel-outlined.MuiInputLabel-shrink': {
      transform: 'translate(14px, -6px) scale(0.75)'
    },
  },
  moreVertContainerLeft: {
    display: 'flex',
    '&:hover .MuiIconButton-root': {
      visibility: 'visible'
    },
    '& .MuiTableSortLabel-root.MuiTableSortLabel-active.MuiTableSortLabel-root.MuiTableSortLabel-active .MuiTableSortLabel-icon': {
      color: 'rgb(163, 102, 255)'
    }
  },
  moreVertContainerRight: {
    display: 'flex',
    flexDirection: 'row-reverse',
    '&:hover .MuiIconButton-root': {
      visibility: 'visible'
    },
    '& .MuiTableSortLabel-root.MuiTableSortLabel-active.MuiTableSortLabel-root.MuiTableSortLabel-active .MuiTableSortLabel-icon': {
      color: 'rgb(163, 102, 255)'
    } 
  },
  iconButtonVert: {
    width: 20,
    height: 20,
    visibility: 'hidden'
  },
  moreVert: {
    fontSize: '0.75em',
    color: theme.palette.text.secondary,
  },
  table: {
    position: 'relative',
    minWidth: 1050,
    minHeight: 400,
    // marginTop: 4,
    '& tbody, tr':{
      backgroundColor: 'rgba(26, 26, 26, 0.975)'
    },
    '& .action-button': {
      color: theme.palette.text.secondary,
      width: 38,
      height: 38
    },
    '@media (max-width:750px)': {
      display: 'block',
      minWidth: 270,
      '& thead': {
        display: 'none'
      },
      '& tbody, tr, th, td': {
        display: 'block',
        width: '100%',
      },
      '& tbody':{
        backgroundColor: 'transparent'
      },
      '& tbody tr':{
        marginBottom: '4px',
      },
      '& th, td': {
        textAlign: 'left',
        // paddingLeft: '30%',
        position: 'relative',
        border: 'none'
      },
      '& th, td:first-child': {
        textAlign: 'center',
        fontSize: '18px',
        width: '100%',
        textTransform: 'capitalize',
        fontWeight: 700,
        // padding: '0 16px'
      },
      '& td:before': {
        display: 'block',
        content: 'attr(data-label)',
        // position: 'absolute',
        left: 0,
        width: '100%',
        textAlign: 'left',
        fontStyle: 'italic',
        fontWeight: 700,
        color: theme.palette.text.secondary,
      },      
    }
  },
  imageCell: {
    width: 104,
    '@media (max-width:750px)': {
      width: '100%'
    }
  },
  image: {
    display: 'block',
    margin: 'auto',
    borderRadius: '5px',
    width: 'auto',
    maxWidth: '80px', 
    minHeight: '100px', 
    maxHeight: '120px', 
    objectFit: 'cover', 
    '@media (max-width:750px)': {
      width: '100%',
      maxWidth: '100%'
    }
  },
  visuallyHidden: {
    border: 0,
    padding: 0,
    height: 15,
    fontSize: '10px',
    fontWeight: 100,
    fontStyle: 'italic',
    color: 'rgb(163, 102, 255)',
    lineHeight: '15px',
    position: 'absolute',
    top: 18,
    width: '100px',
  },
  normalCell: {
    padding : '12px',
    '@media (max-width:750px)': {
      padding: '8px 16px'
    }
  },
  smallCell: {
    padding : '8px',
    '@media (max-width:750px)': {
      padding: '5px 16px'
    }
  },
  checkbox: {
    padding: '0 0 0 4px',
    width: 46,
    '& .MuiSvgIcon-root': {
      color: 'rgb(144, 144, 144)'
    },
    '@media (max-width:750px)': {
      padding: 0,
    }
  },
  pagination: {
    backgroundColor: 'rgba(26, 26, 26, 0.975)',
    '& .MuiTablePagination-toolbar': {
      paddingLeft: 16,
      paddingRight: 16,
    },
    '& .MuiSelect-selectMenu': {
      minHeight: 0
    },
    '& .MuiInputBase-input': {
      padding: '10px 24px 10px 0px'
    },
    '& .MuiSelect-nativeInput': {
      top: 0
    },
    '@media (max-width:750px)': {
      '& .MuiTablePagination-selectRoot': {
        margin: '0px 8px'
      },
      '& .MuiTablePagination-actions': {
        marginLeft: '8px'
      },
      '& .MuiIconButton-root': {
        padding: '8px'
      }
    }
  },
  switch: {
    // display: 'none',
    position: 'absolute',
    top: 48.5,
    left: '-150%',
    zIndex: theme.zIndex.tooltip,
    backgroundColor: '#202020',
    boxShadow: theme.shadows[10],
    borderRadius: 4,
    padding: '8px 16px',
    transition: 'all 1s ease',
    '& .MuiSwitch-track': {
      opacity: 1,
      backgroundColor: 'rgba(40, 40, 40, 1)'
    },
    '& .MuiSwitch-root': {
      height: 36,
      // '& .MuiSwitch-switchBase': {
      //   top: '0px',
      // },  
      '& .MuiSwitch-thumb': {
        height: 18,
        width: 18
      },
    },
  },
  switchOpen: {
    // display: 'block',
    left: 8,
    '@media (max-width:750px)': {
      display: 'none'
    }
  },
  searchSwitch: {
    '& .Mui-focused': {
      color: 'rgb(163, 102, 255)'
    },
    marginBottom: 12,
    '& .MuiInput-underline:after': {
      borderBottomColor: 'rgb(163, 102, 255)'
    },
    '& .MuiInput-root': {
      color: 'white',
      foontWeight: 300
    }
  }
}));

export default function GamesTable() {
  const classes = useStyles();
  const [order, setOrder] = React.useState('asc');
  const [orderBy, setOrderBy] = React.useState('genre');
  const [selected, setSelected] = React.useState([]);
  const [page, setPage] = React.useState(0);
  const [dense, setDense] = React.useState(false);
  const [rowsPerPage, setRowsPerPage] = React.useState(5);
  const {
    user,
    games, 
    setGames,
    fetchGames,
    setFetchGames,
    curIdGames,
    setCurIdGames,
    showFilteredItems, 
    setShowFilteredItems,
    headCells, 
    setHeadCells,
  } = useContext(UserContext);
  let history = useHistory();

  useEffect(() => {
    const fetchData = async () => {
      const result = await axios.get(`https://backendexample.sanbersy.com/api/data-game`); 
      console.log(result.data)
      setGames(result.data.map((el) => { 
        if (Boolean(el.name) === false) el.name = " ";
        if (Boolean(el.genre) === false) el.genre = " ";
        if (Boolean(el.release) === false) el.release = " ";
        if (Boolean(el.platform) === false) el.platform = " ";
        if (Boolean(el.singlePlayer) === false) el.singlePlayer = 0;
        if (Boolean(el.multiplayer) === false) el.multiplayer = 0;
        let name = el.name.charAt(0).toUpperCase() + el.name.slice(1)
        let genre = el.genre.charAt(0).toUpperCase() + el.genre.slice(1)
        let platform = el.platform.charAt(0).toUpperCase() + el.platform.slice(1)
        const { id, release, singlePlayer, multiplayer, image_url } = el;
        return { id, name, release, genre, platform, singlePlayer, multiplayer, image_url };
      }));
    }
    if (fetchGames) {
      fetchData();
      setFetchGames(false);
    }
  },[fetchGames]);

  const handleEdit = (event) => { 
    let edId = parseInt(event.currentTarget.value);
    // setCurIdGames(edId);
    history.push(`/${user.email}/dashboard/game-editor/edit/${edId}`);
  }

  const handleDelete = (event) => {
    let delId = parseInt(event.target.value); 
    axios.delete(`https://backendexample.sanbersy.com/api/data-game/${delId}`).then(() => {
      setFetchGames(true);
    }); 
  }

  function truncateString(str, num) {
    if (str === null) return '';
    if (str.length <= num) return str;
    return str.slice(0, num) + '...';
  }

  const modeCheck = (single, multi) => {
    if ( single && multi ) {
      return <span>Single Player <br/> Multi Player</span>
    }
    if ( single && !multi ) return 'Single Player';
    if ( !single && multi ) return 'Multi Player';
  } 
  
  const descendingComparator = (a, b, orderBy) => {
    // Comparing each Array by choosen Object property
    if (b[orderBy] < a[orderBy]) return -1;
    if (b[orderBy] > a[orderBy]) return 1;
    return 0;
  }

  const getComparator = (order, orderBy) => {
    return order === 'desc'
      ? (a, b) => descendingComparator(a, b, orderBy)
      : (a, b) => -descendingComparator(a, b, orderBy);
  }

  function stableSort(array, comparator) {
    console.log(array);
    const stabilizedThis = array.map((el, index) => [el, index]);
    console.log(stabilizedThis);
    stabilizedThis.sort((a, b) => {
      const order = comparator(a[0], b[0]);
      // console.log(descendingComparator(a, b, orderBy));
      // console.log(order);
      if (order !== 0) return order;
      return a[1] - b[1];
    });
    return stabilizedThis.map((el) => el[0]);
  }
  
  const handleRequestSort = (event, property) => {
    console.log(event);
    console.log(property);
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };

  const handleResetFilter = () => {
    setFetchGames(true);
  }

  const handleSortOrderBy = (event) => {
    console.log(event.target.value)
    setOrderBy(event.target.value)
  }

  const handleSortDirection = (event) => {
    console.log(event.target.value)
    setOrder(event.target.value)
  }

  const handleSelectAllClick = (event) => {
    if (event.target.checked) {
      const newSelecteds = games.map((n) => n.id);
      setSelected(newSelecteds);
      console.log(newSelecteds);
      return;
    }
    setSelected([]);
  };

  const handleClick = (event, id) => {
    console.log(event);
    console.log(id);
    const selectedIndex = selected.indexOf(id);
    console.log(selectedIndex);
    let newSelected = [];

    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, id);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
      // or :
      // newSelected = newSelected.concat(selected.slice(0, selected.length-1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        selected.slice(0, selectedIndex),
        selected.slice(selectedIndex + 1),
      );
    }
    console.log(newSelected)
    setSelected(newSelected);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    console.log(event.target.value);
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleChangeDense = (event) => {
    console.log(event.target.checked);
    setDense(event.target.checked);
  };

  const isSelected = (id) => selected.indexOf(id) !== -1;

  const emptyRows = rowsPerPage - Math.min(rowsPerPage, games.length - page * rowsPerPage);

  return (
    <div className={classes.root}>
      <Paper className={classes.paper}>
        <CustomTableToolbar 
          history={history}
          user={user}
          selected={selected}
          numSelected={selected.length} 
          onResetFilter={handleResetFilter} 
          games={games} 
          setGames={setGames} 
          showFilteredItems={showFilteredItems} 
          setShowFilteredItems={setShowFilteredItems} 
        />
        <TableContainer style={{marginTop: 4}}>
          <Grid container className={classes.sortMobileContainer}>
            <Grid item xs={12} style={{fontSize: '16px', padding: '0px 8px 8px 8px'}}>Sort</Grid>
            <Grid item xs={6} className={classes.sortMobile}>
              <TextField
                select
                variant="outlined"
                margin="normal"
                label="Sort By"
                onChange={handleSortOrderBy}
                value={orderBy}
              >
                {orderBy !== '' && <MenuItem value="">Unsort All</MenuItem>}
                <MenuItem value="name">Name</MenuItem>
                <MenuItem value="genre">Genre</MenuItem>
                <MenuItem value="release">Release</MenuItem>
                <MenuItem value="platform">Platform</MenuItem>
              </TextField>
            </Grid>
            <Grid item xs={6} className={classes.sortMobile}>
              <TextField
                select
                variant="outlined"
                margin="normal"
                label="Sort Direction"
                onChange={handleSortDirection}
                value={order}
              >
                <MenuItem value="asc">Ascending</MenuItem>
                <MenuItem value="desc">Descending</MenuItem>
              </TextField>
            </Grid>
          </Grid>
          <Table
            className={classes.table}
            aria-labelledby="tableTitle"
            size={dense ? 'small' : 'medium'}
            aria-label="custom table"
          >
            <CustomTableHead
              classes={classes}
              games={games}
              numSelected={selected.length}
              order={order}
              orderBy={orderBy}
              setOrderBy={setOrderBy}
              onSelectAllClick={handleSelectAllClick}
              onRequestSort={handleRequestSort}
              rowCount={games.length}
              headCells={headCells}
              setHeadCells={setHeadCells}
            />
            <TableBody>
              {stableSort(games, getComparator(order, orderBy))
                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                .map((game, index) => {
                  console.log(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                  const isItemSelected = isSelected(game.id);
                  const labelId = `custom-table-checkbox-${index}`;

                  return (
                    <TableRow
                      hover
                      // onClick={(event) => handleClick(event, game.title)}
                      // role="checkbox"
                      aria-checked={isItemSelected}
                      tabIndex={-1}
                      key={game.id}
                      selected={isItemSelected}
                    >
                      <TableCell 
                        align="center"
                        className={classes.checkbox}
                      >
                        <Checkbox
                          onClick={(event) => handleClick(event, game.id)}
                          checked={isItemSelected}
                          inputProps={{ 'aria-labelledby': labelId }}
                        />
                      </TableCell>

                      {headCells[0].isVisible && (
                        <TableCell 
                          align="left"
                          data-label="Name"
                          component="th" 
                          id={labelId} 
                          scope="row" 
                          title={game.name}
                          classes={{
                            root: classes.normalCell,
                            sizeSmall: classes.smallCell
                          }}
                        >
                          {truncateString(game.name, 35)}
                        </TableCell>
                      )}

                      {headCells[1].isVisible && (
                        <TableCell 
                          // style={{ background: `url(${game.image_url}) center/100% 100% no-repeat fixed` }}
                          className={classes.imageCell}
                          align="center"
                          classes={{
                            root: classes.normalCell,
                            sizeSmall: classes.smallCell
                          }}
                        >
                          <img 
                            className={classes.image}
                            src={game.image_url}
                            // alt={`${game.name} image`}
                          />  
                        </TableCell>
                      )}

                      {headCells[2].isVisible && (
                        <TableCell 
                          // className="merged-4"
                          data-label="Genre"
                          align="left"
                          classes={{
                            root: classes.normalCell,
                            sizeSmall: classes.smallCell
                          }}
                        >
                          {game.genre}
                        </TableCell>
                      )}

                      {headCells[3].isVisible && (
                        <TableCell 
                          // className="merged-4"
                          data-label="Release"
                          align="right"
                          classes={{
                            root: classes.normalCell,
                            sizeSmall: classes.smallCell
                          }}
                        >
                          {game.release}
                        </TableCell>
                      )}

                      {headCells[4].isVisible && (
                        <TableCell 
                          // className="merged-4"
                          data-label="Platform"
                          align="left"
                          classes={{
                            root: classes.normalCell,
                            sizeSmall: classes.smallCell
                          }}
                        >
                          {game.platform}
                        </TableCell>
                      )}

                      {headCells[5].isVisible && (
                        <TableCell 
                          // className="merged-4"
                          data-label="Mode"
                          align="left"
                          classes={{
                            root: classes.normalCell,
                            sizeSmall: classes.smallCell
                          }}
                          style={{minWidth: 120}}
                        >
                          {modeCheck(game.singlePlayer, game.multiplayer)}
                        </TableCell>
                      )}

                      {headCells[6].isVisible && (
                        <TableCell align="center" padding='none' style={{minWidth: 100, textAlign: 'center'}}>
                          <IconButton 
                            className="action-button"
                            onClick={handleEdit}
                            value={game.id}
                          >
                            <EditRoundedIcon fontSize='medium' />
                          </IconButton>
                          <IconButton 
                            className="action-button"
                            onClick={handleDelete}
                            value={game.id}
                          >
                            <DeleteRoundedIcon fontSize='medium' />
                          </IconButton>
                          {/* <Button onClick={handleEdit} value={game.id}>Edit</Button>
                          <Button onClick={handleDelete} value={game.id}>Delete</Button> */}
                        </TableCell>
                      )}
                    </TableRow>
                  );
                })}
                {/* {games.length < 3 && emptyRows > 0 && (
                  <TableRow style={{ height: (dense ? 80 : 100) * emptyRows }}>
                    <></>
                  </TableRow>
                )} */}
              {games.length === 0 && (
                <TableRow style={{ height: 350 }}>
                  <TableCell></TableCell>
                  {headCells.map(v => v.isVisible && <TableCell></TableCell>)}
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>
        <TablePagination
          className={classes.pagination}
          labelRowsPerPage='Rows per page :'
          rowsPerPageOptions={[5, 10, 25]}
          component="div"
          count={games.length}
          rowsPerPage={rowsPerPage}
          page={page}
          onChangePage={handleChangePage}
          onChangeRowsPerPage={handleChangeRowsPerPage}
        />
      </Paper>
      <FormControlLabel
        control={<Switch checked={dense} onChange={handleChangeDense} />}
        label="Dense padding"
      />
    </div>
  );
}